export const breadcrumbs: { [k: string]: string } = {
  orders: 'Заказы',
  create: 'Создать новый заказ',
  'access-manage': 'Управление доступами',
  'add-user': 'Добавление пользователя',
  'edit-user': 'Редактирование',
  logs: 'Логи',
  clients: 'Клиенты',
  'general-info': 'Общие данные',
  'edit-client': 'Редактирование',
  'order-history': 'История заказов',
  'bonus-history': 'История бонусов',
  'saved-addresses': 'Сохраненные адреса',
  analytics: 'Аналитика',
  'guest-metrics': 'Метрики гостя',
  'financial-metrics': 'Финансовые метрики',
  'menu-metrics': 'Метрики меню',
  'loyalty-programs': 'Программа лояльности',
  gck: 'ЖЦК',
  delivery: 'Доставка',
  branch: 'Филиал',
  menu: 'Меню',
  'app-interaction': 'Взаимодействие с приложением',
  satisfaction: 'Удовлетворенность',
  engagement: 'Вовлеченность',
  'knowledge-base': 'База знаний',
  support: 'Поддержка клиентов',
}
